/* global espn_ui jQuery */
import React from 'react'
// Should move to common utils
import { formatDuration } from './Video'
import { urlWithParams } from '../../lib/utils/common'
import selectn from 'selectn'

export class VideoSlider extends React.Component {

  loadVideoBehavior() {
    try {
      if(!this.slider.querySelectorAll('.slick-track').length) {
        jQuery(this.slider).data('videoPackageEnabled', false)
        espn_ui.loadBehaviorNamed('video_package', this.slider)
      }
    } catch(e) {
      console.log(e)
    }
  }

  shouldComponentUpdate(nextProps = {}) {
    const nextVideos = selectn('videos', nextProps) || []
    const prevVideos = selectn('props.videos', this) || []
    const isPlaying = jQuery(this.slider).find('object, video').size() ? true : false
    let shouldUpdate = false

    if (nextVideos.length != prevVideos.length) {
      shouldUpdate = isPlaying ? false : true
    }

    return shouldUpdate
  }

  componentDidMount() {
    this.loadVideoBehavior()
  }

  componentDidUpdate() {
    this.loadVideoBehavior()
  }

  render() {

    const {
      videos = []
    } = this.props

    const videoList = videos.slice(0, 5).map((video, i) => {

      const thumbnail = video.thumbnail
      const duration = video.duration
      const desktopThumb = urlWithParams(thumbnail, 'w=943', 'h=530')
      const mobileThumb = [ urlWithParams(thumbnail, 'w=375'), urlWithParams(thumbnail, 'w=750', 'cquality=40 2x') ].join(',')

      return `
        <div class="item" data-id="${video.id}" data-index="${i}">
          <div class="item-content">
            <div class="caption">
                <div class="content">
                  <span>${video.headline}</span>
                </div>
            </div>
            <figure class="feed-item-figure video video-carousel" data-source="${video.source}" data-id="${video.id}" data-video="native,640,360,${video.id}">
              <div class="img-wrap">
                <picture>
                  <source srcset="${desktopThumb}" media="(min-width: 376px)" />
                  <source srcset="${mobileThumb}" media="(max-width: 375px)" />
                  <img class="lazyloaded imageLoaded" data-image-container=".article-figure">
                </picture>
                <span class="video-play-button ">Play</span>
                <span class="video-length">${duration ? formatDuration(duration) : ''}</span>
              </div>
            </figure>
          </div>
        </div>
      `
    } )

    const videoHtml = `
      <div id="carousel" class="carousel video-playlist">
          ${videoList.join('')}
      </div>
    `

    const content = (
      <div className="content"><article ref={(ref) => this.slider = ref} className="carousel-item" data-behavior="video_package" dangerouslySetInnerHTML={{ __html: videoHtml }} /></div>
    )

    return videos.length ? content : <div style={{ display:'none' }} />
  }
}

export default VideoSlider



/** WEBPACK FOOTER **
 ** ../app/components/common/VideoSlider.jsx
 **/